// src/components/WhatsAppFloat.js
import React from 'react';
import '../Pages/Style.css';

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/918861182974"
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      title="Chat with us on WhatsApp"
    >
      <img
        src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
        alt="WhatsApp"
        width="50"
        height="50"
      />
    </a>
  );
};

export default WhatsAppFloat;
